import { lazy } from "lazy-var";

const lazyTracking = lazy(
    async () =>
        await import(
            /* webpackFetchPriority: "high" */
            "./tracking"
        )
);

export async function getTracking() {
    return await lazyTracking.get();
}
